import { useQuery } from '@tanstack/react-query';
import { fetchBlogArticles, fetchBlogArticleByHandle, type ShopifyBlogArticle } from '@/lib/shopifyBlog';

export function useBlogArticles(first = 20) {
  return useQuery<ShopifyBlogArticle[]>({
    queryKey: ['blog-articles', first],
    queryFn: () => fetchBlogArticles(first),
    staleTime: 1000 * 60 * 5,
  });
}

export function useBlogArticle(handle: string | undefined) {
  return useQuery<ShopifyBlogArticle | null>({
    queryKey: ['blog-article', handle],
    queryFn: () => fetchBlogArticleByHandle(handle!),
    enabled: !!handle,
    staleTime: 1000 * 60 * 5,
  });
}
